import { Controller } from "@hotwired/stimulus";

// Allows theme selection with live preview by updating data-theme on <html>
export default class extends Controller {
  static targets = ["select"];
  static values = { current: { type: String, default: "corporate" } };

  connect() {
    this._applyTheme(this.currentValue);
  }

  change() {
    const theme = this.selectTarget.value;
    this.currentValue = theme;
    this._applyTheme(theme);
  }

  // Private

  _applyTheme(theme) {
    document.documentElement.setAttribute("data-theme", theme);
  }
}
